import { dateShortString } from "utils/date-format";
import Image from "vino/components/Image";
import { getFrequencyText } from "models/subscription";
import capitalize from "lodash/capitalize";

function SubscriptionListItem({ subscription }) {
	const { subscriptionProducts, status } = subscription;
	let variant = null;
	let product = null;
	if (subscriptionProducts.nodes.length) {
		const subscriptionProduct = subscriptionProducts.nodes[0];
		variant = subscriptionProduct.variant;
		product = variant.product;
	}

	return (
		<tr>
			<td>{dateShortString(subscription.createdAt)}</td>
			<td>
				{variant && (
					<div className="d-flex align-items-center">
						<div className="symbol symbol-45px me-5">
							<Image product={product} />
						</div>
						<div className="d-flex justify-content-start flex-column">
							<div className="text-dark fw-bolder text-hover-primary fs-6">
								{product.name}
							</div>
							<span className="text-muted fw-bold text-muted d-block fs-7">
								{variant.name}
							</span>
						</div>
					</div>
				)}
			</td>
			<td className="justify-end">{subscription.bottles}</td>
			<td>{getFrequencyText(subscription.frequency)}</td>
			<td>-</td>
			<td>-</td>
			<td>{capitalize(status)}</td>
			<td></td>
		</tr>
	);
}
export default SubscriptionListItem;
